import { CalendarCheck, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import AdminSectionLayout from "../components/admin/AdminSectionLayout";

/**
 * AdminBookings — Feb 6, 2026 (preview-fix Feb 6, 2026 PM).
 *
 * Bookings management does not yet have its own dedicated admin
 * pages — the data still lives in the legacy admin panel. Rather
 * than show three tiles that all secretly open the same page, this
 * section is honest: one explicit CTA into the legacy panel, plus a
 * note about what's coming. The 6-card hub link still goes to its
 * own dedicated route (/admin/bookings) so back-navigation is correct.
 */
export default function AdminBookings() {
  return (
    <AdminSectionLayout
      title="Bookings"
      subtitle="Lessons · payments · cancellations"
      icon={CalendarCheck}
      accent="emerald"
      testid="admin-bookings-page"
    >
      <div
        data-testid="admin-bookings-empty-state"
        className="rounded-2xl bg-white border border-slate-200 p-5"
      >
        <p className="text-sm font-extrabold text-slate-900 leading-tight">
          Booking-level admin is in the legacy panel
        </p>
        <p className="text-xs text-slate-500 mt-1.5 leading-snug">
          Lesson history, booking-linked payments, cancellations and no-shows are
          still surfaced from the legacy admin while we migrate them onto their
          own dedicated pages here.
        </p>
        <Link
          to="/admin/legacy"
          data-testid="admin-bookings-legacy-link"
          className="mt-3 inline-flex items-center gap-2 text-sm font-bold text-emerald-600 hover:text-emerald-700"
        >
          <ExternalLink className="w-4 h-4" />
          Open legacy admin
        </Link>
      </div>
    </AdminSectionLayout>
  );
}
